import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { ProductDataDTO } from "~/domains/product/types/ProductDataDTO";
import type { ProductData } from "~/domains/product/types/ProductData";
import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";

type ResponseType = Pick<
  ProductDataDTO,
  | "designation"
  | "sapMaterialNumber"
  | "aliases"
  | "shortDescription"
  | "url"
  | "preferred"
  | "images"
  | "manufacturerLogoUrl"
  | "code"
  | "productAllCategories"
  | "quantityVisible"
>[];

type FCCRecommendationsProps = {
  results?: ResponseType;
};

export async function fetchFccRecommendedProducts(): Promise<ProductData[]> {
  const url = occUrl("/search/fccGap/recommendations");

  const response = await occFetch(url);

  if (response.redirected) {
    window.location.reload();
  } else if (response.ok) {
    const data: FCCRecommendationsProps = await response.json();
    return (data.results ?? []).map((product) => transformProduct(product as ProductDataDTO));
  }
  throw new Error("Error fetching data");
}
